<mat-form-field class="w-50">
    <input
            class="text-center text-xl"
            matInput

            [formControl]="fGroup.get('keyValue')"

            type="text"

            placeholder="0000"
            maxlength="4"
            inputmode="numeric"
            pattern="[0-9]*"

            autocomplete="off"

            digitOnly
    >
    <mat-error>
        {{errorLabels.invalidYearRange|translateLabel: curLang}}
    </mat-error>
</mat-form-field>
